class GiftWithPurchase extends HTMLElement {

    static cartUpdateQueue = Promise.resolve();

    constructor() {
        super();
        if(this.dataset.type == 'popup') {
            this.dialog = this.querySelector('dialog')
            this.close = this.querySelector('.close')
            this.close.addEventListener('click', this.onCloseClick.bind(this))
            this.dialog.addEventListener('click', this.onCloseDialog.bind(this))
            this.button = this.querySelector('[data-modal-open]')
            if(this.button) {
                this.button.addEventListener('click', this.onOpenClick.bind(this))
            }
        }
        this.forms = this.querySelectorAll('form')
        if(this.forms.length > 0) {
            this.forms.forEach((form)=>{
                form.addEventListener('submit', this.onSubmit.bind(this))
            })
        }
        this.cards = this.querySelectorAll('.card.gwp')
        if(this.cards.length > 0) {
            this.cards.forEach((card)=>{
                card.addEventListener('click', this.onCardClick.bind(this))
            })
        }
        this.loadingOverlay = this.querySelector('.loading-overlay')
        this.selects = this.querySelectorAll('.select dl')
        if(this.selects.length > 0) {
            this.selects.forEach((dl)=>{
                dl.addEventListener('click', this.selectClick.bind(dl))
                dl.addEventListener('mouseleave', this.selectLeave.bind(dl))
            })
        }
        this.selectOptions = this.querySelectorAll('.select li')
        if(this.selectOptions.length > 0) {
            this.selectOptions.forEach((li)=>{
                li.addEventListener('click', this.selectOptionClick.bind(this))
            })
        }
        if(this.dataset.autoGift == 'true') {
            this.querySelector('[data-remove]')?.addEventListener('click', this.removeAura.bind(this))
        }
        document.addEventListener("swiper-loaded", this.initCartSwiper.bind(this))
        this.initCartSwiper()
        this.getCartToken().then(() => {
            this.onCartUpdate()
        })
    }
  
    initialize() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.onCartUpdate();
        });

        this.onCartUpdate()
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
            return;
        }
        this.onCartUpdate();
      });
      if(sessionStorage.getItem('aura') === 'removed') this.classList.add('hidden');
    }
  
    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    async getCartToken() {
        const cart = await this.getCart();
        const cartToken = cart.token;
        this.cartToken = cartToken;
    }

    async getCart() {
        const cart = await fetch('/cart.js').then(res => res.json());
        return cart;
    }

    onSubmit() {
        this.classList.add('sending')
        // console.log(event.target)
    }

    removeAura() {
        sessionStorage.setItem('aura', 'removed');
        this.classList.add('hidden');
        this.onCartUpdate();
    }

    onCardClick(event) {
        if(this.classList.contains('sending')) {
            return;
        }
        let card = event.target.closest('.card.gwp')
        let button = card.querySelector('button')
        if(card && !button.contains(event.target)) {
            card.querySelector('button').click()
        }
    }

    onOpenClick() {
        this.dialog.showModal()
        this.dialog.classList.add('open')
    }
    
    onCloseDialog(event) {
        if(event.target == this.dialog) {
            this.onCloseClick()
        }
    }

    onCloseClick() {
        this.dialog.close()
        this.dialog.classList.remove('open')
        this.setCookie('gwp_closed', true, 1)
    }

    onCartUpdate() {
        const updateCart = () => this.reconcileCart().catch((error) => {
            console.error('Error:', error);
        });

        GiftWithPurchase.cartUpdateQueue = GiftWithPurchase.cartUpdateQueue.then(updateCart, updateCart);
        return GiftWithPurchase.cartUpdateQueue;
    }

    async reconcileCart() {
        const self = this;        
        const isAuraRemoved = sessionStorage.getItem('aura') === 'removed';
        let onlyGiftCardAndSampleInCart = false;

        const cartObj = await this.getCart();
        const { items } = cartObj;
        this.cartToken = cartObj.token;

        // Cart sections can replace this component while an update is in flight.
        // Let the newly rendered instance reconcile the current cart instead of
        // acting on stale data attributes from the disconnected instance.
        if (!this.isConnected) {
            return;
        }

        const gwpItem = items.find(item => item.properties?.GWP === 'FREE GIFT !!!');
        const isGWPRemoved = sessionStorage.getItem(`gwp_removed-${this.cartToken}`) === 'true';
        
        if (items.length == 2 &&
            items.some(item => item.gift_card) &&
            gwpItem) {
            onlyGiftCardAndSampleInCart = true;
        }
        
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if(this.dataset.type == 'popup' && this.dataset.hasGwp == 'false' && (parseInt(this.dataset.subtotal) >= parseInt(this.dataset.threshold) || this.dataset.allowed == 'true')) {
            if(!this.isClosed()) {
                this.dialog.showModal();
                this.dialog.classList.add('open')
            }
        }
        if(gwpItem && ((cartObj.total_price < parseInt(this.dataset.threshold)) || this.dataset.allowed == 'false' || isAuraRemoved || (this.querySelector("[data-eligible]")?.dataset.eligible == 'false' && this.dataset.autoGift == 'true') || onlyGiftCardAndSampleInCart)) {
            console.log('remove GWP')
            let formData = {
                'id': gwpItem.key,
                'quantity': 0,
                'sections': cart.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then((response) => {
                cart.renderContents(response);
                self.handleRecharge()
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }        
        if (this.querySelector("[data-eligible]")?.dataset.eligible == 'true' && !isAuraRemoved && !isGWPRemoved && this.dataset.autoGift == 'true' && !gwpItem && (cartObj.total_price >= parseInt(this.dataset.threshold) && this.dataset.allowed == 'true')) {
            console.log('add GWP')
            let formData = {
                'items': [{
                    'id': this.querySelector("[data-auto-gift-id]")?.dataset.autoGiftId,
                    'quantity': 1,
                    properties: {
                        'GWP': 'FREE GIFT !!!',
                        // '__free_sample': 'Aura'
                    }
                }],
                'sections': cart.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then((response) => {
                cart.renderContents(response);
                self.handleRecharge()
            })
            .catch((error) => {
                console.error('Error:', error);
            });
            
        }
    }

    handleRecharge() {
        if(typeof reChargeCartJS == 'function') {
            console.log('CU - sample 2')
            let hasSubscriptions = false
            const newItems = document.querySelectorAll('.cart-item');
            newItems.forEach((item)=>{
                if(item.dataset.isSubscription) {
                    if(JSON.parse(item.dataset.isSubscription)) {
                        hasSubscriptions = true
                    }
                }
            })
            window.ReCharge.cart_options.disable = !hasSubscriptions;
            reChargeCartJS()
        } 
    }

    isClosed() {
        let gwpClosed = this.getCookie("gwp_closed");
        if (gwpClosed) {
            return true;
        } else {
            return false
        }
    }

    showLoader() {
        this.loadingOverlay.classList.remove('hidden')
    }
    
    hideLoader() {
        this.loadingOverlay.classList.add('hidden')
    }

    selectOptionClick(event) {
        event.preventDefault()
        event.stopPropagation();
        this.showLoader()
        // console.log(event.target)

        event.target.closest('dl').classList.remove('active')

        const variantId = event.target.dataset.variantId
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const self = this

        let formData = {
            'items': [{
                'id': variantId,
                'quantity': 1,
                properties: {
                    'GWP': 'FREE GIFT !!!'
                }
            }],
            'sections': cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
        };
        console.log(formData);
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            cart.renderContents(response);
            self.handleRecharge() // TODO check if recharge needs handling
            self.hideLoader()
        })
        .catch((error) => {
            console.error('Error:', error);
            self.hideLoader()
        });
    }

    selectLeave(event) {
        this.classList.remove('active')
    }

    selectClick(event) {
        this.classList.toggle('active')
    }

    initCartSwiper() {
        if(typeof this.swiperGWP == 'undefined' && typeof Swiper != 'undefined') {
            this.swiperGWP = new Swiper(this.querySelector('.swiper'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                freeMode: false,
                slidesPerView: this.querySelectorAll('.gift-products .swiper-slide').length > 1 ? 1.2 : 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.querySelector('.gift-products .swiper-button-next'),
                    prevEl: this.querySelector('.gift-products .swiper-button-prev')
                },
                pagination: {
                    el: this.querySelector('.gift-products .swiper-pagination'),
                    type: 'bullets',
                }
            })
        }
        if(typeof this.swiperTR == 'undefined' && typeof Swiper != 'undefined') {
            this.swiperTR = new Swiper(this.querySelector('.trigger-products.swiper'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                freeMode: false,
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: this.querySelector('.trigger-products + .actions .swiper-button-next'),
                    prevEl: this.querySelector('.trigger-products + .actions .swiper-button-prev')
                },
                pagination: {
                    el: this.querySelector('.trigger-products + .actions .swiper-pagination'),
                    type: 'bullets',
                }
            })
        }
    }

    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

customElements.define('gift-with-purchase', GiftWithPurchase);